import { PLAYBACK_POLL_INTERVAL_MS } from '@mixwire/contracts';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { fetchSuggesterView } from '../api/client.js';
import { suggesterViewQueryKey } from '../api/queryKeys.js';
import { useReportPoll } from '../sync/usePollCycle.js';

import type { PartySlug, SuggesterToken, SuggesterView } from '@mixwire/contracts';

/** Same server-named schedule as the projector — see `usePartyView`. */
export const useSuggesterView = (
  slug: PartySlug,
  token: SuggesterToken,
): UseQueryResult<SuggesterView> => {
  const query = useQuery({
    queryKey: suggesterViewQueryKey(slug),
    queryFn: async () => fetchSuggesterView(slug, token),
    refetchInterval: (current) =>
      current.state.data?.sync.nextPollInMs ?? PLAYBACK_POLL_INTERVAL_MS,
    staleTime: 0,
  });

  useReportPoll(query.data?.sync, query.dataUpdatedAt);

  return query;
};
